<template>
	<div>
		<v-navigation-drawer
			app
			width="200"
			class="appBar"
			:class="{
				appBarTopLight: $vuetify.breakpoint.mdAndDown && !$vuetify.theme.isDark,
				appBarTopDark: $vuetify.breakpoint.mdAndDown && $vuetify.theme.isDark,
			}"
			v-model="drawer"
			mobile-breakpoint="800"
		>
			<v-list>
				<a :href="landingUrl">
					<logo style="width: 150px; height: 50px;" />
				</a>
			</v-list>
			<v-divider></v-divider>
			<v-list nav tile>
				<v-list-item link to="/guest/account">
					<v-icon :class="$route.name === 'account-guest' ? 'primary--text' : ''">
						mdi-account-cog-outline
					</v-icon>
					<v-list-item-title>Cuenta</v-list-item-title>
				</v-list-item>
				<v-list-item link to="/guest/timeline">
					<v-icon :class="$route.name === 'timeline' ? 'primary--text' : ''">
						mdi-playlist-check
					</v-icon>
					<v-list-item-title>Actividades</v-list-item-title>
				</v-list-item>
				<v-list-item link to="/guest/team">
					<v-icon :class="$route.name === 'team' ? 'primary--text' : ''">
						mdi-account-group
					</v-icon>
					<v-list-item-title>Mi equipo</v-list-item-title>
				</v-list-item>
				<v-list-item link to="/guest/documents">
					<v-icon :class="$route.name === 'documents-person' ? 'primary--text' : ''">
						mdi-folder-text-outline
					</v-icon>
					<v-list-item-title>
						<v-badge class="mt-2" :value="documentBadge" color="error" dot>
							Documentos
						</v-badge>
					</v-list-item-title>
				</v-list-item>
				<v-list-item link :to="{ name: 'publications' }">
					<v-icon :class="$route.name === 'publications' ? 'primary--text' : ''">
						mdi-pdf-box
					</v-icon>
					<v-list-item-title>
						<v-badge class="mt-2" :value="documentBadge" color="error" dot>
							Publicaciones beta
						</v-badge>
					</v-list-item-title>
				</v-list-item>
				<v-list-item link to="/contact-us">
					<v-icon :class="$route.name === 'contact' ? 'primary--text' : ''">
						mdi-email-send-outline
					</v-icon>
					<v-list-item-title>Ayuda</v-list-item-title>
				</v-list-item>
				<v-divider />
				<v-list-item
					v-if="loggedIn"
					class="mb-5"
					active-class="primary--text"
					@click="logout"
					data-cy="personLogOut"
				>
					<v-icon>mdi-logout</v-icon>
					<v-list-item-title>Cerrar sesión</v-list-item-title>
				</v-list-item>
				<v-list-item v-else active-class="primary--text" to="/auth">
					<v-icon>mdi-account-arrow-light-outline</v-icon>
					<v-list-item-title>Iniciar sesión</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<v-app-bar
			app
			height="50"
			class="appBar"
			:class="{
				appBarTopLight: !$vuetify.theme.isDark,
				appBarTopDark: $vuetify.theme.isDark,
				backgroundMorado: !$vuetify.theme.isDark,
			}"
		>
			<div class="title text--secondary text-capitalize">
				{{ $route.meta.title }}
			</div>
			<v-spacer />
			<v-icon @click="requestNotificationPermissions">mdi-bell-outline</v-icon>
			<v-icon @click="toggleTheme">mdi-theme-light-dark</v-icon>
			<v-app-bar-nav-icon @click.stop="drawer = !drawer" />
		</v-app-bar>
		<v-main>
			<transition-page>
				<router-view />
			</transition-page>
		</v-main>
	</div>
</template>

<script>
import { logout } from '@/plugins/auth';
import { landing } from '@/config';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	name: 'GuestLayout',
	components: {
		Logo: () => import('@/assets/logo'),
		TransitionPage: () => import('@/components/ui/TransitionPage'),
	},
	data() {
		return {
			drawer: false,
		};
	},
	computed: {
		landingUrl() {
			return landing;
		},
		...mapGetters({ documentBadge: 'Person/documentBadge', person: 'Person/person' }),
	},
	mounted() {
		this.initFetch();
		this.requestNotificationPermissions(true);
	},
	methods: {
		async initFetch() {
			this.setGlobalLoading(true);
			await this.getPerson(this.userProfile.idPerson);
			await this.getLodgingsOfPerson(this.userProfile.idPerson);
			// obtenermos el perfil del admin
			if (this.person && this.person.idCompany)
				await this.fetchProfileById(this.person.idCompany);
			this.setDocumentBadge();
			this.setGlobalLoading(false);
		},
		toggleTheme() {
			this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
			this.$vuetify.theme.themes.dark.$card = '#192734';
			if (this.$vuetify.theme.isDark) {
				localStorage.setItem('mode', 'dark');
			} else {
				localStorage.setItem('mode', 'light');
			}
		},
		async requestNotificationPermissions(mounted = false) {
			const permission = Notification.permission;
			if (permission === 'denied' && mounted) {
				this.snackbar({
					content:
						'Notificaciones bloqueadas. Verifica que tus notificaciones esten activadas o que no estes en un navegador modo incognito',
					color: 'warning',
				});
			} else if (permission === 'default' && mounted) {
				await Notification.requestPermission();
				this.snackbar({
					content: 'Notificaciones activadas',
					color: 'success',
				});
			} else if (permission === 'granted' && mounted) {
				this.snackbar({
					content: 'Las notificaciones ya estan activadas',
					color: 'success',
				});
			}
		},
		async logout() {
			logout().then(() => this.$router.replace({ path: '/auth' }));
		},
		...mapActions({
			fetchProfileById: 'User/fetchProfileById',
			getPerson: 'Person/getPerson',
			getLodgingsOfPerson: 'Lodging/getLodgingsOfOnlyPerson',
		}),
		...mapMutations({
			setGlobalLoading: 'User/setGlobalLoading',
			setDocumentBadge: 'Person/setDocumentBadge',
			snackbar: 'Snackbar/showMessage',
		}),
	},
};
</script>

<style lang="scss">
.appBar {
	font-family: roboto;
	background-color: transparent !important;
}

.appBarTopLight {
	font-family: roboto;
	background-color: white !important;
}

.appBarTopDark {
	font-family: roboto;
	background-color: black !important;
}
</style>
